import React, { useEffect } from "react";
import LocationPopUpModal from "../LocationPopUp/LocationPopUpModal";
import { useLocationPermission } from "./LocationPermissionContext";

const LocationPermissionWrapper = ({ children }) => {
  const {
    showModal,
    errorMessage,
    openLocationModal,
    closeLocationModal,
    setErrorMessage,
  } = useLocationPermission();

  // The useEffect that automatically triggers the location popup on mount
  // has been removed to satisfy the requirement: "ask whenever it is utmost required only".
  // The location modal will now only appear when explicitly called via openLocationModal.

  // 🌍 When user clicks "Allow"
  const handleAllow = () => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;

        localStorage.setItem("latitude", latitude);
        localStorage.setItem("longitude", longitude);

        // ✅ Save permission status permanently
        localStorage.setItem("locationPermissionGranted", "true");

        closeLocationModal();
      },
      () => {
        openLocationModal(
          "Please allow location access in your browser settings."
        );
      },
      { enableHighAccuracy: true, timeout: 8000 }
    );
  };

  // 📝 User chooses manual entry
  const handleManual = () => {
    // ✅ Save permission status permanently
    localStorage.setItem("locationPermissionGranted", "true");
    closeLocationModal();
  };

  // ❌ User closes popup manually (temporary dismissal for this session)
  const handleClose = () => {
    // Save dismissal flag for this session only
    sessionStorage.setItem("locationPopupDismissed", "true");
    closeLocationModal();
  };

  return (
    <>
      {showModal && (
        <LocationPopUpModal
          onAllow={handleAllow}
          onManual={handleManual}
          onClose={handleClose}
          errorMessage={errorMessage}
        />
      )}

      {children}
    </>
  );
};

export default LocationPermissionWrapper;
